import { type ItemDataType } from './sharedTypes';

export const initServiceItems = [
  {
    itemId: 'item1',
    itemName: null,
    taiwanPayPrice: null,
    pointPrice: null,
    reservationLowerLimit: null,
    reservationUpperLimit: null,
    display: true,
  },
];

export const timeUnits = [
  { label: '天', value: 'day' },
  { label: '週', value: 'week' },
  { label: '月', value: 'month' },
];

export const checkIsItemNoAnyValue = (args: {
  item: ItemDataType;
  isTaiwanPayChecked: boolean;
  isPointChecked: boolean;
}) => {
  const { item, isTaiwanPayChecked, isPointChecked } = args;

  const isNoAnyValue = Object.keys(item).every((key) => {
    if (item.display === false) {
      return true;
    }

    if (
      key === 'itemId' ||
      key === 'display' ||
      key === 'cleanKindId' ||
      key === 'createdTime' ||
      key === 'updatedTime'
    ) {
      return true;
    }

    if (
      (isTaiwanPayChecked === false && key === 'taiwanPayPrice') ||
      (isPointChecked === false && key === 'pointPrice')
    ) {
      return true;
    }

    if (typeof item[key] === 'string') {
      return !item[key];
    }

    return item[key] !== 0 && !item[key];
  });

  return isNoAnyValue;
};
